import GameStatusBadge from '../GameStatusBadge/GameStatusBadge';
import './GameCard.css';

export default function GameCard({
  title,
  subtitle,
  coverUrl,
  status,
  slug,
  priceCents,
  currency,
  isFree,
  subscriptionIncluded,
  accessVia,
  onlyAccessVia,
  cardCount,
  onClaim,
  onClick = () => { }
}) {
  return (
    <div className="game-card" role="button" tabIndex={0} onClick={onClick} onKeyDown={(e) => { if (e.key === 'Enter') onClick(); }}>
      <img className="game-cover" src={coverUrl} alt={title} />
      <div className="game-meta">
        <div className="game-title">{title}</div>
        <div className="game-subtitle">{subtitle}</div>
        <div className="game-actions">
          <GameStatusBadge
            status={status}
            priceCents={priceCents}
            currency={currency}
            isFree={isFree}
            subscriptionIncluded={subscriptionIncluded}
            accessVia={accessVia}
            onlyAccessVia={onlyAccessVia}
            cardCount={cardCount}
          />
        </div>
      </div>
    </div>
  );
}
